import Swal from "sweetalert2";

import {
  customerKey,
  authKey,
} from "../constants/defaultValues";

export const camelToSnake = (jsonObj) => {
  if (Array.isArray(jsonObj)) {
    return jsonObj.map(item => camelToSnake(item));
  } else if (typeof jsonObj === 'object') {
    return Object.keys(jsonObj).reduce((acc, key) => {
      const snakeKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
      acc[snakeKey] = camelToSnake(jsonObj[key]);
      return acc;
    }, {});
  } else {
    return jsonObj;
  }
}

export const validateBilling = (name, value) => {
  switch (name) {
    case ("firstName"):
      if (value.length === 0) {
        return "First name is required"
      } else if (!/^[A-Za-z\s]+$/.test(value)) {
        return "First name is not valid"
      } else {
        return ""
      }
    case ("lastName"):
      if (value.length === 0) {
        return "Last name is required"
      } else if (!/^[A-Za-z\s]+$/.test(value)) {
        return "Last name is not valid"
      } else {
        return ""
      }
    case ("email"):
      if (value.length === 0) {
        return "Email is required"
      } else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) === false) {
        return "Email is not valid"
      } else {
        return ""
      }
    case ("cfCountry"):
      if (value.length === 0) {
        return "Country is required"
      } else {
        return ""
      }
    case ("cfState"):
      if (value.length === 0) {
        return "State is required"
      } else {
        return ""
      }
    case ("cfCity"):
      if (value.length === 0) {
        return "City is required"
      } else {
        return ""
      }
    case ("cfAddress"):
      if (value.length === 0) {
        return "Address is required"
      } else {
        return ""
      }
    case ("cfDialCountryCode"):
      if (value === "") {
        return "Dial code is required"
      } else {
        return ""
      }
    case ("cfSinglePhoneNumber"):
      if (value.length === 0) {
        return "Phone number is required"
      } else if (!/^\d+$/.test(value)) {
        return "Phone number is not valid"
      } else if (value.length <= 7) {
        return "Phone number must be longer"
      } else if (value.length >= 12) {
        return "Phone number must be shorter"
      } else {
        return ""
      }
    default:
      return ""
  }
}

export const validateCard = (name, value, card) => {
  switch (name) {
    case ("firstName"):
      if (value.length === 0) {
        return "Card name is required"
      } else if (!/^[a-zA-Z\s'-]+$/.test(value)) {
        return "Card name is not valid"
      } else {
        return ""
      }
    case ("lastName"):
      if (value.length === 0) {
        return "Card name is required"
      } else if (!/^[a-zA-Z\s'-]+$/.test(value)) {
        return "Card name is not valid"
      } else {
        return ""
      }
    case ("expiryMonth"):
      if (value.length === 0) {
        return "Expiry month is required"
      } else if (card.expiryYear.value === "") {
        return "Please select the year first"
      } else if (value < new Date().getMonth() && card.expiryYear.value === new Date().getFullYear()) {
        return "The card can not be expired"
      } else {
        return ""
      }
    case ("expiryYear"):
      if (value.length === 0) {
        return "Expiry year is required"
      } else {
        return ""
      }
    case ("maskedNumber"):
      if (value.length === 0) {
        return "Card number is required"
      } else if (!/^[0-9]{16}$/.test(value)) {
        return "Card number is not valid"
      } else {
        return ""
      }
    case ("cvc"):
      if (value.length === 0) {
        return "CVC is required"
      } else if (!/^[0-9]{3}$/.test(value)) {
        return "CVC is not valid"
      } else {
        return ""
      }
    default:
      return ""
  }
}

export const renderCardYear = () => {
  let n = 15
  let currenYear = new Date().getFullYear()
  let arr = [...Array(n).keys()];
  return arr.map((year, index) => (
    <option key={index} value={currenYear + year}>
      {currenYear + year}
    </option>
  ))
}

export const renderCardMonth = () => {
  let n = 12
  let arr = [...Array(n).keys()];
  return arr.map((month, index) => (
    <option key={index} value={month + 1}>
      {month + 1}
    </option>
  ))
}

export const inputStatus = (object, key) => {
  if (object[key]) {
    if (object[key].focused) {
      if (object[key].error === "") {
        return "input--group input--success"
      } else {
        return "input--group input--error"
      }
    } else {
      return "input--group"
    }
  }
}

/*LOCAL STORAGE*/

export const setCustomer = (data) => {
  try{
    localStorage.setItem(customerKey, data);
  }catch(error){
    console.log(`>>>> setCustomer -> error: ${error}`)
  }
}

export const getCustomer = () => {
  let data = "";
  try {
    if (localStorage.getItem(customerKey)){
      data = localStorage.getItem(customerKey)
    }
  } catch (error){
    console.log(`>>>> getCustomer -> error: ${error}`)
  }
  return data;
}

export const setAuth = (data) => {
  try {
    localStorage.setItem(authKey, data);
  } catch (error) {
    console.log(`>>>> setAuth -> error: ${error}`)
  }
}

export const getAuth = () => {
  let data = "";
  try {
    if (localStorage.getItem(authKey)) {
      data = localStorage.getItem(authKey)
    }
  } catch (error) {
    console.log(`>>>> getAuth -> error: ${error}`)
  }
  return data;
}

export const focusInput = (ev) => {
  if (ev.target.tagName === 'LABEL') {
    ev.target.nextElementSibling.focus();
  } else if (ev.target.tagName === 'DIV') {
    let children = ev.target.children
    for (let i = 0; i < children.length; i++) {
      if (children[i].tagName === 'INPUT') {
        children[i].focus()
      }
    }
  }
}

export const setNotification = (payload) => {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
      popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 10000,
    timerProgressBar: true
  })
  switch (payload.type) {
    case 'error':
      Swal.fire({
        icon: 'error',
        title: `${payload.title}`,
        html: `${payload.message}`,
        confirmButtonText: "Contact Marquet Support",
        showConfirmButton: true,
        showCancelButton: true,
        didOpen() {
          let confirmButtons = document.getElementsByClassName("swal2-confirm")[0]
          confirmButtons.style.backgroundColor = "#611C35";
          confirmButtons.style.color = "#ffffff";
          confirmButtons.style.border = "#611C35";
          confirmButtons.style.boxShadow = "none";
          let cancelButton = document.getElementsByClassName("swal2-cancel")[0]
          confirmButtons.style.boxShadow = "none";
          cancelButton.style.backgroundColor = "#ffffff";
          cancelButton.style.color = "#611C35";
          cancelButton.style.border = "1px solid #611C35";
          confirmButtons.style.boxShadow = "none";
        }
      }).then((result) => {
        if (result.isConfirmed) {
          window.open('https://marquet.atlassian.net/servicedesk', '_blank');
        }
      })
      break;
    case 'success':
      Toast.fire({
        icon: 'success',
        title: `${payload.title}`,
        iconColor: '#a5dc86',
        html: `${payload.message}`,
        showCloseButton: true
      })
      break;
    case 'warning':
      Toast.fire({
        icon: 'warning',
        title: `${payload.title}`,
        iconColor: '#f8bb86',
        html: `${payload.message}`,
        showCloseButton: true
      })
      break;
    case 'info':
      Toast.fire({
        icon: 'info',
        title: `${payload.title}`,
        iconColor: '#3195a5',
        html: `${payload.message}`,
        showCloseButton: true
      })
  }
};